if (!customElements.get('tiny-inline-buy-v2')) {
  customElements.define('tiny-inline-buy-v2', class extends HTMLElement {
    connectedCallback() {
      this.closest('.product-item')?.classList.add('tiny-inline-buy-active');
      if (this.initialized) return;
      this.initialized = true;
      this.addEventListener('click', (event) => {
        const button = event.target.closest('[data-variant-id]');
        if (!button || !this.contains(button) || button.disabled) return;
        const submit = this.querySelector('[data-js-product-add-to-cart]');
        if (submit.disabled || submit.getAttribute('aria-disabled') === 'true' || submit.classList.contains('working')) return;
        this.querySelector('input[name="id"]').value = button.dataset.variantId;
        this.querySelectorAll('[data-variant-id]').forEach(option => {
          option.setAttribute('aria-pressed', String(option === button));
        });
        this.querySelectorAll('[data-tiny-price]').forEach(element => {
          element.textContent = button.dataset.price;
        });
        const compare = this.querySelector('[data-tiny-compare]');
        compare.textContent = button.dataset.compare;
        compare.hidden = !button.dataset.compare;
        this.updateImage(button.dataset.variantId);
      });
      this.updateImage(this.querySelector('[aria-pressed="true"]')?.dataset.variantId || this.dataset.initialVariant);
    }
    updateImage(variantId) {
      const card = this.closest('.product-item');
      const link = card?.querySelector('.product-item__image');
      const templates = Array.from(this.querySelectorAll('template[data-tiny-media]'));
      const index = templates.findIndex(item => item.dataset.tinyMedia === variantId);
      if (!link || index < 0 || link.dataset.tinyMedia === variantId) return;
      clearTimeout(this.slideTimer);
      const previous = link.querySelector('[data-tiny-current]');
      const previousIndex = templates.findIndex(item => item.dataset.tinyMedia === link.dataset.tinyMedia);
      const next = templates[index].content.firstElementChild.cloneNode(true);
      const image = next.querySelector('img');
      if (image) image.loading = 'eager';
      next.setAttribute('data-tiny-current', '');
      link.classList.remove('product-item__image--has-secondary');
      link.classList.add('tiny-inline-buy__viewport');
      link.dataset.tinyMedia = variantId;
      const reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (!previous || reducedMotion) {
        link.replaceChildren(next);
        return;
      }
      previous.removeAttribute('data-tiny-current');
      previous.setAttribute('aria-hidden', 'true');
      previous.classList.remove('tiny-slide-in', 'tiny-slide-out');
      const direction = index >= previousIndex ? 1 : -1;
      previous.style.setProperty('--tiny-slide-exit', (-direction * 100) + '%');
      next.style.setProperty('--tiny-slide-enter', (direction * 100) + '%');
      previous.classList.add('tiny-slide-out');
      next.classList.add('tiny-slide-in');
      link.replaceChildren(previous, next);
      this.slideTimer = setTimeout(() => {
        previous.remove();
        next.classList.remove('tiny-slide-in');
      }, 380);
    }
  });
}
